import React from 'react';
import { Footer } from '@massds/mayflower-react';

import './index.scss';

export default (props) => <Footer {...props} />;
